import React from 'react';
import { SparePiece } from 'react-chessboard';
import { AUGMENTS } from '../augments/catalog';

export function Bench({
  theme,
  benchIds,
  benchNonce,
  benchGlowActive,
  showBenchHint,
  unitIdByBenchId,
  augmentsByUnitId,
  ensureBenchPieceVariant,
  getAugmentTooltip,
  getUiPieceRenderer,
  onSetCurrentSpare
}) {
  const square = 560 / 8;
  const benchTypes = ['wP', 'wN', 'wB', 'wR', 'wQ'];
  const items = benchTypes.flatMap(pt => (benchIds[pt] || []).map(id => ({ pt, id })));

  return (
    <div 
      className={benchGlowActive ? 'gc-glow-blue' : ''} 
      style={{ 
        width: 560, 
        boxSizing: 'border-box', 
        margin: '8px auto', 
        border: '2px dotted #333', 
        borderRadius: 8, 
        padding: 8, 
        userSelect: 'none', 
        cursor: 'default' 
      }}
    >
      <div style={{ textAlign: 'left', float: 'left', marginBottom: 4 }}>
        <span style={{ fontWeight: 700 }}>Bench</span>
        {showBenchHint ? (
          <span style={{ marginLeft: 6, color: theme === 'dark' ? '#bbb' : '#777', fontWeight: 400 }}>(drag onto board)</span>
        ) : null}
      </div>
      {items.length === 0 ? (
        <div style={{ height: 70, clear: 'both' }} />
      ) : (
        <div style={{ clear: 'both', display: 'grid', gridTemplateColumns: 'repeat(6, 1fr)' }}>
          {items.map(({ pt, id }) => {
            const unitId = (unitIdByBenchId || {})[id] || null;
            const augId = unitId ? (augmentsByUnitId?.[unitId]?.augmentId || null) : null;
            const colorKey = augId ? (AUGMENTS[augId]?.color || null) : null;
            const variant = ensureBenchPieceVariant(pt, colorKey, id);
            const tooltip = augId ? getAugmentTooltip(augId) : null;
            const overlayKey = colorKey ? (pt + '_' + String(colorKey).toLowerCase()) : pt;
            const OverlayComp = getUiPieceRenderer(overlayKey);
            return (
              <div
                key={'bench-'+pt+'-'+id+'-'+(benchNonce||0)}
                style={{ 
                  width: `${square}px`, 
                  height: `${square}px`, 
                  position: 'relative', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  overflow: 'visible' 
                }}
                onMouseDown={() => onSetCurrentSpare('bench', pt, id)}
                onTouchStart={() => onSetCurrentSpare('bench', pt, id)}
                data-bench-id={id}
                title={tooltip || undefined}
              >
                {/* Invisible draggable SparePiece to preserve drag behavior */}
                <div style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', opacity: OverlayComp ? 0 : 1 }}>
                  <SparePiece pieceType={variant} />
                </div>
                {OverlayComp ? (
                  <div aria-hidden="true" style={{ position: 'absolute', inset: 0, display: 'flex', alignItems: 'center', justifyContent: 'center', pointerEvents: 'none' }}>
                    <OverlayComp />
                  </div>
                ) : null}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

